import { render, staticRenderFns } from "./Barras.vue?vue&type=template&id=7a7a3a79&"
import script from "./Barras.vue?vue&type=script&lang=js&"
export * from "./Barras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports